"use client";

import { Calendar, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Intervention() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: panelRef,
    isVisible: panelVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: mapRef,
    isVisible: mapVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: satellitesRef,
    isVisible: satellitesVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const hours = [{
    day: "LUN–VEN",
    time: "09:00–18:00"
  }, {
    day: "SAM",
    time: "10:00–17:00"
  }, {
    day: "DIM",
    time: "FERMÉ"
  }];
  const satellites = [{
    city: "GENÈVE",
    status: "DISPONIBLE",
    coords: "46.2044°N / 6.1432°E"
  }, {
    city: "NYON",
    status: "DISPONIBLE",
    coords: "46.3833°N / 6.2333°E"
  }, {
    city: "LA CÔTE",
    status: "DISPONIBLE",
    coords: "46.4500°N / 6.3000°E"
  }];
  return;
}